function hideCartDrawer(){
    $(".cart-drawer").removeClass("active");
    $(".body-overlay, .cart-overlay").removeClass("cart-active");
    $("body").removeClass("active"); 
  }
  
  function showCartDrawer(type){
    if(type == 'b2c'){
      $(".cart-drawer").addClass("active");
      $(".cart-overlay").addClass("cart-active");
      $("body").addClass("active");
    } else {
        window.location.href = "/cart";
    }
  }
  

  function setCountry(code){
    if(code || code==''){
        var text = jQuery('a[cunt_code="'+code+'"]').html();
        $(".dropdown dt a span").html(text);
    }
}
$(document).ready(function() {
    $(".dropdown img.flag").addClass("flagvisibility");

    $(".dropdown dt a").click(function() {
        $(".dropdown dd ul").toggle();
    });

    $(".dropdown dd ul li a").click(function() {
        //console.log($(this).html())
        var text = $(this).html();
        $(".dropdown dt a span").html(text);
        $(".dropdown dd ul").hide();
        $("#result").html("Selected value is: " + getSelectedValue("country-select"));
    });

    function getSelectedValue(id) {
        //console.log(id,$("#" + id).find("dt a span.value").html())
        return $("#" + id).find("dt a span.value").html();
    }

    $(document).bind('click', function(e) {
        var $clicked = $(e.target);
        if (! $clicked.parents().hasClass("dropdown"))
            $(".dropdown dd ul").hide();
    });


    $("#flagSwitcher").click(function() {
        $(".dropdown img.flag").toggleClass("flagvisibility");
    });
});